const getTableAccessorKey = (key) => {
  return key && key.split('__').join('.');
};

export default getTableAccessorKey;
